// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.credit-detail-shell {
  min-height: 100vh;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: var(--font-family-primary);
}
.credit-detail-main {
  margin-left: 256px;
  min-width: 0;
}
.credit-detail-page {
  padding: var(--space-8);
  max-width: 1600px;
  margin: auto;
}
.credit-detail-breadcrumb,
.credit-detail-back,
.credit-detail-actions,
.credit-detail-document > header,
.credit-detail-document > header > div {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}
.credit-detail-breadcrumb {
  font-size: var(--font-size-body-sm);
  color: var(--text-secondary);
  margin-bottom: var(--space-6);
}
.credit-detail-page a {
  color: var(--interactive-default);
  text-decoration: none;
}
.credit-detail-heading {
  display: flex;
  justify-content: space-between;
  gap: var(--space-6);
  align-items: center;
  margin-bottom: var(--space-6);
}
.credit-detail-heading h1 {
  font-size: var(--font-size-h1);
  line-height: 1.25;
  margin: var(--space-3) 0;
}
.credit-detail-heading p,
.credit-detail-context p {
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
  line-height: 1.6;
}
.credit-detail-back {
  font-size: var(--font-size-body-sm);
}
.credit-detail-button {
  height: 40px;
  min-height: 40px;
  border: 1px solid var(--border-default);
  background: var(--surface-primary);
  color: var(--text-primary) !important;
  border-radius: 10px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-style: normal;
  font-weight: var(--font-weight-medium, 500);
  line-height: normal;
  letter-spacing: 0;
  cursor: pointer;
}
.credit-detail-button.primary {
  background: var(--interactive-default);
  color: var(--on-interactive-primary) !important;
  border-color: var(--interactive-default);
}
.credit-detail-button > svg:not(.MuiCircularProgress-svg) {
  width: 16px;
  height: 16px;
}
.credit-detail-button:not(.primary):not(:disabled):hover {
  border-color: var(--interactive-default);
  background: var(--interactive-soft-hover);
  color: var(--text-primary) !important;
}
.credit-detail-button.primary:not(:disabled):hover {
  border-color: var(--interactive-hover);
  background: var(--interactive-hover);
  color: var(--on-interactive-primary) !important;
}
.credit-detail-button .MuiCircularProgress-root {
  color: currentColor;
}
.credit-detail-button.primary:not(:disabled):active {
  border-color: var(--interactive-pressed);
  background: var(--interactive-pressed);
}
.credit-detail-button:disabled {
  opacity: 0.6;
  cursor: wait;
}
.credit-detail-button:focus-visible,
.credit-detail-page a:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 3px;
}
.credit-detail-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-4);
  margin-bottom: var(--space-6);
}
.credit-detail-card {
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  padding: var(--space-6);
  min-width: 0;
}
.credit-detail-summary span,
.credit-detail-summary small {
  display: block;
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
.credit-detail-summary strong {
  display: block;
  font-size: var(--font-size-h3);
  margin: var(--space-3) 0;
  overflow-wrap: anywhere;
}
.credit-detail-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  align-items: start;
  gap: var(--space-6);
}
.credit-detail-page h2 {
  font-size: var(--font-size-h4);
  margin: 0;
}
.credit-detail-page h3 {
  font-size: var(--font-size-body-md);
  margin: var(--space-2) 0;
}
.credit-detail-document > header {
  justify-content: space-between;
  padding-bottom: var(--space-5);
  border-bottom: 1px solid var(--border-default);
}
.credit-detail-badge {
  background: var(--surface-secondary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-full);
  padding: var(--space-1) var(--space-3);
  font-size: var(--font-size-body-xs);
}
.credit-detail-identities {
  display: flex;
  justify-content: space-between;
  gap: var(--space-6);
  padding: var(--space-6) 0;
}
.credit-detail-identities span {
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
.credit-detail-page dl {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: var(--space-6);
  row-gap: var(--space-3);
  font-size: var(--font-size-body-sm);
  margin: 0;
}
.credit-detail-page dt {
  color: var(--text-secondary);
}
.credit-detail-page dd {
  margin: 0;
  text-align: right;
  overflow-wrap: anywhere;
}
.credit-detail-table-scroll {
  overflow-x: auto;
}
.credit-detail-page table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-body-sm);
  white-space: nowrap;
}
.credit-detail-page caption {
  text-align: left;
  color: var(--text-secondary);
  padding-bottom: var(--space-3);
}
.credit-detail-page th {
  background: var(--surface-secondary);
  color: var(--text-secondary);
  text-align: left;
  font-weight: 500;
}
.credit-detail-page th,
.credit-detail-page td {
  padding: var(--space-3);
  border-bottom: 1px solid var(--border-default);
}
.credit-detail-page td small {
  display: block;
  color: var(--text-secondary);
  white-space: normal;
  min-width: 120px;
  margin-top: var(--space-1);
}
.credit-detail-page td:nth-child(n + 3),
.credit-detail-page th:nth-child(n + 3) {
  text-align: right;
}
.credit-detail-totals {
  display: flex;
  justify-content: flex-end;
  padding-top: var(--space-6);
}
.credit-detail-totals dl {
  min-width: 280px;
}
.credit-detail-totals .grand {
  border-top: 1px solid var(--border-default);
  padding-top: var(--space-4);
  font-weight: 600;
  color: var(--text-primary);
  font-size: var(--font-size-h4);
}
.credit-detail-notes {
  border-top: 1px solid var(--border-default);
  margin-top: var(--space-6);
  padding-top: var(--space-4);
}
.credit-detail-notes p {
  white-space: pre-wrap;
  font-size: var(--font-size-body-sm);
  color: var(--text-secondary);
}
.credit-detail-context dl {
  margin: var(--space-5) 0;
}
.credit-detail-context a {
  font-size: var(--font-size-body-sm);
}
.credit-detail-activity {
  margin-top: var(--space-6);
  overflow: hidden;
}
.credit-detail-loaded.is-loading { display: none; }
.adjustment-note-detail-page .credit-detail-breadcrumb {
  margin-bottom: var(--space-4);
  font-size: var(--font-size-caption-md);
  line-height: var(--line-height-caption-md);
  letter-spacing: var(--letter-spacing-caption-md);
}
.adjustment-note-detail-page .credit-detail-heading {
  margin-bottom: var(--space-5);
}
.adjustment-note-detail-page .credit-detail-heading h1 {
  margin: 0 0 var(--space-2);
  font-size: var(--font-size-h1);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-h1);
  letter-spacing: var(--letter-spacing-h1);
}
.adjustment-note-detail-page .credit-detail-heading p {
  margin: 0;
  font-size: var(--font-size-caption-md);
  line-height: var(--line-height-caption-md);
  letter-spacing: var(--letter-spacing-caption-md);
}
.adjustment-note-detail-page .credit-detail-card {
  border-color: var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--elevation-small);
}
.adjustment-note-detail-page .credit-detail-document > header {
  padding-bottom: var(--space-4);
  border-color: var(--border-subtle);
}
.adjustment-note-detail-page .credit-detail-page h2,
.adjustment-note-detail-page h2 {
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-h4);
  letter-spacing: var(--letter-spacing-h4);
}
.adjustment-note-detail-page h3 {
  margin: var(--space-1) 0;
  font-size: var(--font-size-label-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-label-md);
  letter-spacing: var(--letter-spacing-label-md);
}
.adjustment-note-detail-page .credit-detail-identities {
  gap: var(--space-4);
  padding: var(--space-5) 0;
}
.adjustment-note-detail-page .credit-detail-identities span,
.adjustment-note-detail-page .credit-detail-identities p,
.adjustment-note-detail-page dl,
.adjustment-note-detail-page table,
.adjustment-note-detail-page .credit-detail-notes p {
  font-size: var(--font-size-caption-md);
  line-height: var(--line-height-caption-md);
  letter-spacing: var(--letter-spacing-caption-md);
}
.adjustment-note-detail-page .credit-detail-identities p {
  margin: var(--space-2) 0 0;
}
.adjustment-note-detail-page dl {
  column-gap: var(--space-5);
  row-gap: var(--space-2);
}
.adjustment-note-detail-page th,
.adjustment-note-detail-page td {
  padding: 10px var(--space-3);
  border-color: var(--border-subtle);
}
.adjustment-note-detail-page th {
  font-size: var(--font-size-caption-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-caption-md);
  letter-spacing: var(--letter-spacing-caption-md);
}
.adjustment-note-detail-page .credit-detail-totals {
  padding-top: var(--space-5);
}
.adjustment-note-detail-page .credit-detail-totals h2 {
  margin: 0;
}
.adjustment-note-detail-page .credit-detail-notes {
  margin-top: var(--space-5);
  padding-top: var(--space-4);
  border-color: var(--border-subtle);
}
.adjustment-note-detail-page .credit-detail-notes p {
  margin: var(--space-2) 0 0;
}
.adjustment-note-detail-page .credit-detail-badge,
.adjustment-note-detail-page .note-status {
  font-size: var(--font-size-label-sm);
  line-height: var(--line-height-label-sm);
  letter-spacing: var(--letter-spacing-label-sm);
}
.adjustment-note-detail-page .document-activity__header p {
  font-size: var(--font-size-caption-md);
  line-height: var(--line-height-caption-md);
  letter-spacing: var(--letter-spacing-caption-md);
}
.adjustment-note-detail-page .document-activity__list li {
  font-size: var(--font-size-caption-md);
}
.adjustment-note-detail-page .document-activity__list strong {
  font-size: var(--font-size-label-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-label-md);
  letter-spacing: var(--letter-spacing-label-md);
}
.adjustment-note-detail-page .document-activity__list li > span,
.adjustment-note-detail-page .document-activity__list p {
  font-size: var(--font-size-caption-md);
  line-height: var(--line-height-caption-md);
  letter-spacing: var(--letter-spacing-caption-md);
}
.adjustment-note-detail-page .document-activity__list time {
  font-size: var(--font-size-label-sm);
  line-height: var(--line-height-label-sm);
  letter-spacing: var(--letter-spacing-label-sm);
}
.credit-note-detail-skeleton {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}
.credit-note-detail-skeleton__heading,
.credit-note-detail-skeleton__heading > div,
.credit-note-detail-skeleton__actions,
.credit-note-detail-skeleton__document-heading,
.credit-note-detail-skeleton__history-heading,
.credit-note-detail-skeleton__history-heading > div {
  display: flex;
  gap: var(--space-3);
}
.credit-note-detail-skeleton__heading,
.credit-note-detail-skeleton__document-heading,
.credit-note-detail-skeleton__history-heading {
  align-items: flex-start;
  justify-content: space-between;
}
.credit-note-detail-skeleton__heading > div,
.credit-note-detail-skeleton__history-heading > div,
.credit-note-detail-skeleton__summary,
.credit-note-detail-skeleton__aside {
  flex-direction: column;
}
.credit-note-detail-skeleton__document {
  min-height: 500px;
}
.credit-note-detail-skeleton__identity {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.7fr);
  gap: var(--space-8);
  padding: var(--space-5) 0;
}
.credit-note-detail-skeleton__identity > div {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}
.credit-note-detail-skeleton__identity span {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);
}
.credit-note-detail-skeleton__table {
  overflow: hidden;
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
}
.credit-note-detail-skeleton__table > div {
  display: grid;
  grid-template-columns: 1.4fr repeat(4, 1fr);
  gap: var(--space-4);
  align-items: center;
  min-height: 48px;
  padding: 0 var(--space-3);
  border-bottom: 1px solid var(--border-subtle);
}
.credit-note-detail-skeleton__table > div:last-child { border-bottom: 0; }
.credit-note-detail-skeleton__total {
  align-self: flex-end;
  margin: var(--space-5) 0;
}
.credit-note-detail-skeleton__balance {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding-top: var(--space-5);
  border-top: 1px solid var(--border-subtle);
}
.credit-note-detail-skeleton__history {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-height: 210px;
}
.credit-note-detail-skeleton__history-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px var(--space-4);
  padding: var(--space-4) 0;
  border-top: 1px solid var(--border-subtle);
}
.credit-note-detail-skeleton__history-row > :nth-child(n + 3) {
  grid-column: 1 / -1;
}
@media (max-width: 900px) {
  .credit-note-detail-skeleton__identity { grid-template-columns: 1fr; }
}
@media (max-width: 700px) {
  .credit-note-detail-skeleton__heading { flex-direction: column; }
  .credit-note-detail-skeleton__actions { width: 100%; }
  .credit-note-detail-skeleton__actions > * { flex: 1 1; }
  .credit-note-detail-skeleton__table > div { grid-template-columns: 1.4fr repeat(2, 1fr); }
  .credit-note-detail-skeleton__table > div > :nth-child(n + 4) { display: none; }
}
.document-activity__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
}
.document-activity__header h2,
.document-activity__header p,
.document-activity__list p { margin: 0; }
.document-activity__header h2 {
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
}
.document-activity__header p {
  margin-top: 4px;
  font-size: 12px;
  line-height: 18px;
}
.document-activity__header p,
.document-activity__list p,
.document-activity__list time,
.document-activity__empty {
  color: var(--text-secondary);
  font-size: 12px;
}
.document-activity__add-note {
  min-height: 40px;
  padding: 0 var(--space-4);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  color: var(--text-primary);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}
.document-activity__add-note:hover { background: var(--surface-secondary); }
.document-activity__add-note:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
.document-activity__list {
  display: grid;
  gap: 0;
  margin: var(--space-5) 0 0;
  padding: 0;
  list-style: none;
}
.document-activity__list li {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 6px 16px;
  padding: 12px 14px;
  border: 1px solid var(--border-default);
  border-bottom: 0;
  font-size: 12px;
}
.document-activity__list li:first-child {
  border-radius: var(--radius-md) var(--radius-md) 0 0;
}
.document-activity__list li:last-child {
  border-bottom: 1px solid var(--border-default);
  border-radius: 0 0 var(--radius-md) var(--radius-md);
}
.document-activity__list strong {
  color: var(--text-primary);
}
.document-activity__list time {
  grid-column: 2;
  grid-row: 1;
  white-space: nowrap;
}
.document-activity__list li > span,
.document-activity__list li > p {
  grid-column: 1 / -1;
}
.document-activity__list li > span {
  color: var(--text-primary);
  font-weight: 500;
}
.document-activity__list p {
  line-height: 1.5;
}
.document-activity__empty {
  margin: var(--space-5) 0 0;
  padding: var(--space-5);
  border: 1px dashed var(--border-default);
  border-radius: var(--radius-md);
  text-align: center;
}
.document-activity__loading,
.document-activity__error {
  margin-top: var(--space-5);
  padding: var(--space-5);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
.document-activity__loading {
  display: grid;
  grid-template-columns: 10px minmax(120px, 220px) minmax(80px, 140px);
  gap: var(--space-3);
  align-items: center;
  overflow: hidden;
}
.document-activity__loading span {
  height: 14px;
  border-radius: 999px;
  background: var(--surface-tertiary);
  animation: document-activity-pulse 1.4s ease-in-out infinite;
}
.document-activity__loading span:first-child { width: 10px; }
.document-activity__loading span:nth-child(3) { animation-delay: 120ms; }
.document-activity__error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  border-color: var(--danger-border);
  background: var(--danger-soft);
  color: var(--danger-text);
}
.document-activity__error button {
  min-height: 36px;
  padding: 0 var(--space-3);
  border: 1px solid var(--danger-border);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  color: var(--danger-text);
  font: inherit;
  font-weight: var(--font-weight-medium);
  cursor: pointer;
}
@keyframes document-activity-pulse {
  0%, 100% { opacity: 0.45; }
  50% { opacity: 1; }
}
@media (prefers-reduced-motion: reduce) {
  .document-activity__loading span { animation: none; }
}
.note-detail-events-legacy { display: none; }
.document-note-dialog.MuiDialog-paper {
  overflow: hidden;
  border: 1px solid var(--border-default);
  border-radius: 16px;
  background: var(--surface-elevated);
  color: var(--text-primary);
  box-shadow: 0 24px 64px rgba(10, 22, 20, 0.2);
}
.document-note-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-6);
  border-bottom: 1px solid var(--border-subtle);
}
.document-note-dialog__header h2,
.document-note-dialog__header p { margin: 0; }
.document-note-dialog__header h2 {
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-h4);
  letter-spacing: var(--letter-spacing-h4);
}
.document-note-dialog__header p {
  margin-top: var(--space-1);
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
  line-height: var(--line-height-body-sm);
}
.document-note-dialog__header > button {
  display: grid;
  width: 36px;
  height: 36px;
  flex: 0 0 auto;
  place-items: center;
  border: 0;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
}
.document-note-dialog__header > button:hover { background: var(--surface-secondary); }
.document-note-dialog__body { padding: var(--space-6); }
.document-note-dialog__body label {
  display: block;
  margin-bottom: var(--space-2);
  font-size: var(--font-size-label-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-label-md);
  letter-spacing: var(--letter-spacing-label-md);
}
.document-note-dialog__body textarea {
  width: 100%;
  min-height: 144px;
  resize: vertical;
  padding: var(--space-3) var(--space-4);
  border: 0;
  border-radius: var(--radius-md);
  outline: none;
  background: var(--surface-primary);
  color: var(--text-primary);
  font-family: var(--font-family-primary);
  font-size: var(--font-size-body-sm);
  line-height: var(--line-height-body-sm);
}
.document-note-dialog__body textarea:focus {
  outline: 2px solid var(--focus-ring);
  outline-offset: 0;
}
.document-note-dialog__body textarea[aria-invalid="true"] {
  outline: 2px solid var(--danger-default);
}
.document-note-dialog__meta {
  display: flex;
  justify-content: space-between;
  gap: var(--space-3);
  margin-top: var(--space-2);
  color: var(--text-tertiary);
  font-size: var(--font-size-body-xs);
  line-height: var(--line-height-body-xs);
}
.document-note-dialog__meta [role="alert"] { color: var(--danger-text); }
.document-note-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-6) var(--space-6);
}
.document-note-dialog__actions button {
  min-height: 40px;
  padding: 0 var(--space-4);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  color: var(--text-primary);
  font-family: var(--font-family-primary);
  font-size: var(--font-size-label-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-label-md);
  letter-spacing: var(--letter-spacing-label-md);
  cursor: pointer;
}
.document-note-dialog__actions button.primary {
  border-color: var(--interactive-default);
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
}
.document-note-dialog__actions button:hover { background: var(--surface-secondary); }
.document-note-dialog__actions button.primary:hover { background: var(--interactive-hover); }
.document-note-dialog__header button:focus-visible,
.document-note-dialog__actions button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
@media (max-width: 640px) {
  .document-note-dialog__header,
  .document-note-dialog__body { padding: var(--space-4); }
  .document-note-dialog__actions { padding: 0 var(--space-4) var(--space-4); }
  .document-note-dialog__actions button { flex: 1 1; }
}
.credit-detail-error {
  color: var(--danger-text);
}
@media (max-width: 1200px) {
  .credit-detail-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 1024px) {
  .credit-detail-main {
    margin-left: 0;
  }
  .credit-detail-page {
    padding: var(--space-6);
  }
}
@media (max-width: 640px) {
  .credit-detail-page {
    padding: var(--space-4);
  }
  .credit-detail-heading,
  .credit-detail-identities {
    flex-direction: column;
    align-items: stretch;
  }
  .credit-detail-summary {
    grid-template-columns: 1fr;
  }
  .credit-detail-card {
    padding: var(--space-4);
  }
  .credit-detail-actions {
    flex-wrap: wrap;
  }
  .credit-detail-heading h1 {
    font-size: var(--font-size-h2);
  }
  .adjustment-note-detail-page .credit-detail-heading h1 {
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.36px;
  }
  .credit-detail-totals dl {
    min-width: 0;
    width: 100%;
  }
}

.credit-detail-shell * {
  box-sizing: border-box;
}

.credit-detail-notes input { width:100%; padding:var(--space-3); border:1px solid var(--border-default); border-radius:var(--radius-md); background:var(--surface-secondary); color:var(--text-primary); font:inherit; margin:var(--space-3) 0; }

.credit-note-detail-skeleton__heading > div:first-child {
  min-width: 0;
  gap: var(--space-2);
}
.credit-note-detail-skeleton .app-skeleton { max-width: 100%; }
.adjustment-note-detail-page .credit-note-detail-skeleton {
  gap: var(--space-5);
}
.credit-note-detail-skeleton__heading > .credit-note-detail-skeleton__actions {
  flex-direction: row;
  flex-shrink: 0;
}
@media (max-width: 640px) {
  .adjustment-note-detail-page .credit-note-detail-skeleton__heading > div:first-child > .app-skeleton:first-child {
    height: 30px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/CreditNote/creditNoteDetail.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;AACA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;;EAEE,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uCAAuC;EACvC,kCAAkC;EAClC,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,+CAA+C;EAC/C,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,qCAAqC;AACvC;AACA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,+CAA+C;AACjD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;;EAEE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;AACd;AACA;;EAEE,cAAc;EACd,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,8BAA8B;EAC9B,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,8CAA8C;AAChD;AACA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,iCAAiC;EACjC,sCAAsC;EACtC,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,mCAAmC;EACnC,SAAS;AACX;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,uBAAuB;EACvB,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA,mCAAmC,aAAa,EAAE;AAClD;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,0CAA0C;EAC1C,gDAAgD;AAClD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;EAClC,wCAAwC;AAC1C;AACA;EACE,SAAS;EACT,sCAAsC;EACtC,0CAA0C;EAC1C,gDAAgD;AAClD;AACA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;;EAEE,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;EAClC,wCAAwC;AAC1C;AACA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,sCAAsC;EACtC,wCAAwC;EACxC,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;;;;EAKE,sCAAsC;EACtC,0CAA0C;EAC1C,gDAAgD;AAClD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;;EAEE,4BAA4B;EAC5B,kCAAkC;AACpC;AACA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,0CAA0C;EAC1C,gDAAgD;AAClD;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,oCAAoC;EACpC,wCAAwC;EACxC,8CAA8C;AAChD;AACA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,gDAAgD;AAClD;AACA;EACE,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,wCAAwC;EACxC,8CAA8C;AAChD;AACA;;EAEE,sCAAsC;EACtC,0CAA0C;EAC1C,gDAAgD;AAClD;AACA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;;;;;EAME,aAAa;EACb,mBAAmB;AACrB;AACA;;;EAGE,uBAAuB;EACvB,8BAA8B;AAChC;AACA;;;;EAIE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,0DAA0D;EAC1D,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;AAC/C;AACA,uDAAuD,gBAAgB,EAAE;AACzE;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,uBAAuB;EACvB,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yCAAyC,0BAA0B,EAAE;AACvE;AACA;EACE,wCAAwC,sBAAsB,EAAE;EAChE,wCAAwC,WAAW,EAAE;EACrD,4CAA4C,SAAO,EAAE;EACrD,4CAA4C,2CAA2C,EAAE;EACzF,gEAAgE,aAAa,EAAE;AACjF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;;6BAE6B,SAAS,EAAE;AACxC;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;AACA;;;;EAIE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA,qCAAqC,oCAAoC,EAAE;AAC3E;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,MAAM;EACN,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oDAAoD;AACtD;AACA;EACE,8CAA8C;EAC9C,oDAAoD;AACtD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;;EAEE,0BAA0B;EAC1B,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,oEAAoE;EACpE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,mCAAmC;EACnC,4DAA4D;AAC9D;AACA,+CAA+C,WAAW,EAAE;AAC5D,gDAAgD,sBAAsB,EAAE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;EAClC,yBAAyB;EACzB,aAAa;EACb,sCAAsC;EACtC,eAAe;AACjB;AACA;EACE,WAAW,aAAa,EAAE;EAC1B,MAAM,UAAU,EAAE;AACpB;AACA;EACE,mCAAmC,eAAe,EAAE;AACtD;AACA,6BAA6B,aAAa,EAAE;AAC5C;EACE,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,mCAAmC;EACnC,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;AACA;kCACkC,SAAS,EAAE;AAC7C;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;EAClC,wCAAwC;AAC1C;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;EACnC,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;AACA,+CAA+C,oCAAoC,EAAE;AACrF,8BAA8B,uBAAuB,EAAE;AACvD;EACE,cAAc;EACd,6BAA6B;EAC7B,oCAAoC;EACpC,sCAAsC;EACtC,wCAAwC;EACxC,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,uCAAuC;EACvC,mCAAmC;EACnC,uCAAuC;AACzC;AACA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,uCAAuC;AACzC;AACA,6CAA6C,yBAAyB,EAAE;AACxE;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qDAAqD;AACvD;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,uCAAuC;EACvC,oCAAoC;EACpC,sCAAsC;EACtC,wCAAwC;EACxC,8CAA8C;EAC9C,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,oCAAoC;AACtC;AACA,8CAA8C,oCAAoC,EAAE;AACpF,sDAAsD,oCAAoC,EAAE;AAC5F;;EAEE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE;gCAC8B,uBAAuB,EAAE;EACvD,iCAAiC,wCAAwC,EAAE;EAC3E,wCAAwC,SAAO,EAAE;AACnD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;;IAEE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6BAA6B,UAAU,EAAE,sBAAsB,EAAE,sCAAsC,EAAE,8BAA8B,EAAE,mCAAmC,EAAE,yBAAyB,EAAE,YAAY,EAAE,uBAAuB,EAAE;;AAEhP;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA,6CAA6C,eAAe,EAAE;AAC9D;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".credit-detail-shell {\n  min-height: 100vh;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-family: var(--font-family-primary);\n}\n.credit-detail-main {\n  margin-left: 256px;\n  min-width: 0;\n}\n.credit-detail-page {\n  padding: var(--space-8);\n  max-width: 1600px;\n  margin: auto;\n}\n.credit-detail-breadcrumb,\n.credit-detail-back,\n.credit-detail-actions,\n.credit-detail-document > header,\n.credit-detail-document > header > div {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n.credit-detail-breadcrumb {\n  font-size: var(--font-size-body-sm);\n  color: var(--text-secondary);\n  margin-bottom: var(--space-6);\n}\n.credit-detail-page a {\n  color: var(--interactive-default);\n  text-decoration: none;\n}\n.credit-detail-heading {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-6);\n  align-items: center;\n  margin-bottom: var(--space-6);\n}\n.credit-detail-heading h1 {\n  font-size: var(--font-size-h1);\n  line-height: 1.25;\n  margin: var(--space-3) 0;\n}\n.credit-detail-heading p,\n.credit-detail-context p {\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n  line-height: 1.6;\n}\n.credit-detail-back {\n  font-size: var(--font-size-body-sm);\n}\n.credit-detail-button {\n  height: 40px;\n  min-height: 40px;\n  border: 1px solid var(--border-default);\n  background: var(--surface-primary);\n  color: var(--text-primary) !important;\n  border-radius: 10px;\n  padding: 0 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: normal;\n  letter-spacing: 0;\n  cursor: pointer;\n}\n.credit-detail-button.primary {\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary) !important;\n  border-color: var(--interactive-default);\n}\n.credit-detail-button > svg:not(.MuiCircularProgress-svg) {\n  width: 16px;\n  height: 16px;\n}\n.credit-detail-button:not(.primary):not(:disabled):hover {\n  border-color: var(--interactive-default);\n  background: var(--interactive-soft-hover);\n  color: var(--text-primary) !important;\n}\n.credit-detail-button.primary:not(:disabled):hover {\n  border-color: var(--interactive-hover);\n  background: var(--interactive-hover);\n  color: var(--on-interactive-primary) !important;\n}\n.credit-detail-button .MuiCircularProgress-root {\n  color: currentColor;\n}\n.credit-detail-button.primary:not(:disabled):active {\n  border-color: var(--interactive-pressed);\n  background: var(--interactive-pressed);\n}\n.credit-detail-button:disabled {\n  opacity: 0.6;\n  cursor: wait;\n}\n.credit-detail-button:focus-visible,\n.credit-detail-page a:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 3px;\n}\n.credit-detail-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--space-4);\n  margin-bottom: var(--space-6);\n}\n.credit-detail-card {\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  padding: var(--space-6);\n  min-width: 0;\n}\n.credit-detail-summary span,\n.credit-detail-summary small {\n  display: block;\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.credit-detail-summary strong {\n  display: block;\n  font-size: var(--font-size-h3);\n  margin: var(--space-3) 0;\n  overflow-wrap: anywhere;\n}\n.credit-detail-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 280px;\n  align-items: start;\n  gap: var(--space-6);\n}\n.credit-detail-page h2 {\n  font-size: var(--font-size-h4);\n  margin: 0;\n}\n.credit-detail-page h3 {\n  font-size: var(--font-size-body-md);\n  margin: var(--space-2) 0;\n}\n.credit-detail-document > header {\n  justify-content: space-between;\n  padding-bottom: var(--space-5);\n  border-bottom: 1px solid var(--border-default);\n}\n.credit-detail-badge {\n  background: var(--surface-secondary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-full);\n  padding: var(--space-1) var(--space-3);\n  font-size: var(--font-size-body-xs);\n}\n.credit-detail-identities {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-6);\n  padding: var(--space-6) 0;\n}\n.credit-detail-identities span {\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.credit-detail-page dl {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: var(--space-6);\n  row-gap: var(--space-3);\n  font-size: var(--font-size-body-sm);\n  margin: 0;\n}\n.credit-detail-page dt {\n  color: var(--text-secondary);\n}\n.credit-detail-page dd {\n  margin: 0;\n  text-align: right;\n  overflow-wrap: anywhere;\n}\n.credit-detail-table-scroll {\n  overflow-x: auto;\n}\n.credit-detail-page table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--font-size-body-sm);\n  white-space: nowrap;\n}\n.credit-detail-page caption {\n  text-align: left;\n  color: var(--text-secondary);\n  padding-bottom: var(--space-3);\n}\n.credit-detail-page th {\n  background: var(--surface-secondary);\n  color: var(--text-secondary);\n  text-align: left;\n  font-weight: 500;\n}\n.credit-detail-page th,\n.credit-detail-page td {\n  padding: var(--space-3);\n  border-bottom: 1px solid var(--border-default);\n}\n.credit-detail-page td small {\n  display: block;\n  color: var(--text-secondary);\n  white-space: normal;\n  min-width: 120px;\n  margin-top: var(--space-1);\n}\n.credit-detail-page td:nth-child(n + 3),\n.credit-detail-page th:nth-child(n + 3) {\n  text-align: right;\n}\n.credit-detail-totals {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: var(--space-6);\n}\n.credit-detail-totals dl {\n  min-width: 280px;\n}\n.credit-detail-totals .grand {\n  border-top: 1px solid var(--border-default);\n  padding-top: var(--space-4);\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: var(--font-size-h4);\n}\n.credit-detail-notes {\n  border-top: 1px solid var(--border-default);\n  margin-top: var(--space-6);\n  padding-top: var(--space-4);\n}\n.credit-detail-notes p {\n  white-space: pre-wrap;\n  font-size: var(--font-size-body-sm);\n  color: var(--text-secondary);\n}\n.credit-detail-context dl {\n  margin: var(--space-5) 0;\n}\n.credit-detail-context a {\n  font-size: var(--font-size-body-sm);\n}\n.credit-detail-activity {\n  margin-top: var(--space-6);\n  overflow: hidden;\n}\n.credit-detail-loaded.is-loading { display: none; }\n.adjustment-note-detail-page .credit-detail-breadcrumb {\n  margin-bottom: var(--space-4);\n  font-size: var(--font-size-caption-md);\n  line-height: var(--line-height-caption-md);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.adjustment-note-detail-page .credit-detail-heading {\n  margin-bottom: var(--space-5);\n}\n.adjustment-note-detail-page .credit-detail-heading h1 {\n  margin: 0 0 var(--space-2);\n  font-size: var(--font-size-h1);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-h1);\n  letter-spacing: var(--letter-spacing-h1);\n}\n.adjustment-note-detail-page .credit-detail-heading p {\n  margin: 0;\n  font-size: var(--font-size-caption-md);\n  line-height: var(--line-height-caption-md);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.adjustment-note-detail-page .credit-detail-card {\n  border-color: var(--border-subtle);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--elevation-small);\n}\n.adjustment-note-detail-page .credit-detail-document > header {\n  padding-bottom: var(--space-4);\n  border-color: var(--border-subtle);\n}\n.adjustment-note-detail-page .credit-detail-page h2,\n.adjustment-note-detail-page h2 {\n  font-size: var(--font-size-h4);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-h4);\n  letter-spacing: var(--letter-spacing-h4);\n}\n.adjustment-note-detail-page h3 {\n  margin: var(--space-1) 0;\n  font-size: var(--font-size-label-md);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-label-md);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.adjustment-note-detail-page .credit-detail-identities {\n  gap: var(--space-4);\n  padding: var(--space-5) 0;\n}\n.adjustment-note-detail-page .credit-detail-identities span,\n.adjustment-note-detail-page .credit-detail-identities p,\n.adjustment-note-detail-page dl,\n.adjustment-note-detail-page table,\n.adjustment-note-detail-page .credit-detail-notes p {\n  font-size: var(--font-size-caption-md);\n  line-height: var(--line-height-caption-md);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.adjustment-note-detail-page .credit-detail-identities p {\n  margin: var(--space-2) 0 0;\n}\n.adjustment-note-detail-page dl {\n  column-gap: var(--space-5);\n  row-gap: var(--space-2);\n}\n.adjustment-note-detail-page th,\n.adjustment-note-detail-page td {\n  padding: 10px var(--space-3);\n  border-color: var(--border-subtle);\n}\n.adjustment-note-detail-page th {\n  font-size: var(--font-size-caption-md);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-caption-md);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.adjustment-note-detail-page .credit-detail-totals {\n  padding-top: var(--space-5);\n}\n.adjustment-note-detail-page .credit-detail-totals h2 {\n  margin: 0;\n}\n.adjustment-note-detail-page .credit-detail-notes {\n  margin-top: var(--space-5);\n  padding-top: var(--space-4);\n  border-color: var(--border-subtle);\n}\n.adjustment-note-detail-page .credit-detail-notes p {\n  margin: var(--space-2) 0 0;\n}\n.adjustment-note-detail-page .credit-detail-badge,\n.adjustment-note-detail-page .note-status {\n  font-size: var(--font-size-label-sm);\n  line-height: var(--line-height-label-sm);\n  letter-spacing: var(--letter-spacing-label-sm);\n}\n.adjustment-note-detail-page .document-activity__header p {\n  font-size: var(--font-size-caption-md);\n  line-height: var(--line-height-caption-md);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.adjustment-note-detail-page .document-activity__list li {\n  font-size: var(--font-size-caption-md);\n}\n.adjustment-note-detail-page .document-activity__list strong {\n  font-size: var(--font-size-label-md);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-label-md);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.adjustment-note-detail-page .document-activity__list li > span,\n.adjustment-note-detail-page .document-activity__list p {\n  font-size: var(--font-size-caption-md);\n  line-height: var(--line-height-caption-md);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.adjustment-note-detail-page .document-activity__list time {\n  font-size: var(--font-size-label-sm);\n  line-height: var(--line-height-label-sm);\n  letter-spacing: var(--letter-spacing-label-sm);\n}\n.credit-note-detail-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n.credit-note-detail-skeleton__heading,\n.credit-note-detail-skeleton__heading > div,\n.credit-note-detail-skeleton__actions,\n.credit-note-detail-skeleton__document-heading,\n.credit-note-detail-skeleton__history-heading,\n.credit-note-detail-skeleton__history-heading > div {\n  display: flex;\n  gap: var(--space-3);\n}\n.credit-note-detail-skeleton__heading,\n.credit-note-detail-skeleton__document-heading,\n.credit-note-detail-skeleton__history-heading {\n  align-items: flex-start;\n  justify-content: space-between;\n}\n.credit-note-detail-skeleton__heading > div,\n.credit-note-detail-skeleton__history-heading > div,\n.credit-note-detail-skeleton__summary,\n.credit-note-detail-skeleton__aside {\n  flex-direction: column;\n}\n.credit-note-detail-skeleton__document {\n  min-height: 500px;\n}\n.credit-note-detail-skeleton__identity {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.7fr);\n  gap: var(--space-8);\n  padding: var(--space-5) 0;\n}\n.credit-note-detail-skeleton__identity > div {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n.credit-note-detail-skeleton__identity span {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-4);\n}\n.credit-note-detail-skeleton__table {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n}\n.credit-note-detail-skeleton__table > div {\n  display: grid;\n  grid-template-columns: 1.4fr repeat(4, 1fr);\n  gap: var(--space-4);\n  align-items: center;\n  min-height: 48px;\n  padding: 0 var(--space-3);\n  border-bottom: 1px solid var(--border-subtle);\n}\n.credit-note-detail-skeleton__table > div:last-child { border-bottom: 0; }\n.credit-note-detail-skeleton__total {\n  align-self: flex-end;\n  margin: var(--space-5) 0;\n}\n.credit-note-detail-skeleton__balance {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--border-subtle);\n}\n.credit-note-detail-skeleton__history {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-height: 210px;\n}\n.credit-note-detail-skeleton__history-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 8px var(--space-4);\n  padding: var(--space-4) 0;\n  border-top: 1px solid var(--border-subtle);\n}\n.credit-note-detail-skeleton__history-row > :nth-child(n + 3) {\n  grid-column: 1 / -1;\n}\n@media (max-width: 900px) {\n  .credit-note-detail-skeleton__identity { grid-template-columns: 1fr; }\n}\n@media (max-width: 700px) {\n  .credit-note-detail-skeleton__heading { flex-direction: column; }\n  .credit-note-detail-skeleton__actions { width: 100%; }\n  .credit-note-detail-skeleton__actions > * { flex: 1; }\n  .credit-note-detail-skeleton__table > div { grid-template-columns: 1.4fr repeat(2, 1fr); }\n  .credit-note-detail-skeleton__table > div > :nth-child(n + 4) { display: none; }\n}\n.document-activity__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--space-4);\n}\n.document-activity__header h2,\n.document-activity__header p,\n.document-activity__list p { margin: 0; }\n.document-activity__header h2 {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n}\n.document-activity__header p {\n  margin-top: 4px;\n  font-size: 12px;\n  line-height: 18px;\n}\n.document-activity__header p,\n.document-activity__list p,\n.document-activity__list time,\n.document-activity__empty {\n  color: var(--text-secondary);\n  font-size: 12px;\n}\n.document-activity__add-note {\n  min-height: 40px;\n  padding: 0 var(--space-4);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n}\n.document-activity__add-note:hover { background: var(--surface-secondary); }\n.document-activity__add-note:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n.document-activity__list {\n  display: grid;\n  gap: 0;\n  margin: var(--space-5) 0 0;\n  padding: 0;\n  list-style: none;\n}\n.document-activity__list li {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 6px 16px;\n  padding: 12px 14px;\n  border: 1px solid var(--border-default);\n  border-bottom: 0;\n  font-size: 12px;\n}\n.document-activity__list li:first-child {\n  border-radius: var(--radius-md) var(--radius-md) 0 0;\n}\n.document-activity__list li:last-child {\n  border-bottom: 1px solid var(--border-default);\n  border-radius: 0 0 var(--radius-md) var(--radius-md);\n}\n.document-activity__list strong {\n  color: var(--text-primary);\n}\n.document-activity__list time {\n  grid-column: 2;\n  grid-row: 1;\n  white-space: nowrap;\n}\n.document-activity__list li > span,\n.document-activity__list li > p {\n  grid-column: 1 / -1;\n}\n.document-activity__list li > span {\n  color: var(--text-primary);\n  font-weight: 500;\n}\n.document-activity__list p {\n  line-height: 1.5;\n}\n.document-activity__empty {\n  margin: var(--space-5) 0 0;\n  padding: var(--space-5);\n  border: 1px dashed var(--border-default);\n  border-radius: var(--radius-md);\n  text-align: center;\n}\n.document-activity__loading,\n.document-activity__error {\n  margin-top: var(--space-5);\n  padding: var(--space-5);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.document-activity__loading {\n  display: grid;\n  grid-template-columns: 10px minmax(120px, 220px) minmax(80px, 140px);\n  gap: var(--space-3);\n  align-items: center;\n  overflow: hidden;\n}\n.document-activity__loading span {\n  height: 14px;\n  border-radius: 999px;\n  background: var(--surface-tertiary);\n  animation: document-activity-pulse 1.4s ease-in-out infinite;\n}\n.document-activity__loading span:first-child { width: 10px; }\n.document-activity__loading span:nth-child(3) { animation-delay: 120ms; }\n.document-activity__error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  border-color: var(--danger-border);\n  background: var(--danger-soft);\n  color: var(--danger-text);\n}\n.document-activity__error button {\n  min-height: 36px;\n  padding: 0 var(--space-3);\n  border: 1px solid var(--danger-border);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  color: var(--danger-text);\n  font: inherit;\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n}\n@keyframes document-activity-pulse {\n  0%, 100% { opacity: 0.45; }\n  50% { opacity: 1; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .document-activity__loading span { animation: none; }\n}\n.note-detail-events-legacy { display: none; }\n.document-note-dialog.MuiDialog-paper {\n  overflow: hidden;\n  border: 1px solid var(--border-default);\n  border-radius: 16px;\n  background: var(--surface-elevated);\n  color: var(--text-primary);\n  box-shadow: 0 24px 64px rgba(10, 22, 20, 0.2);\n}\n.document-note-dialog__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-6);\n  border-bottom: 1px solid var(--border-subtle);\n}\n.document-note-dialog__header h2,\n.document-note-dialog__header p { margin: 0; }\n.document-note-dialog__header h2 {\n  font-size: var(--font-size-h4);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-h4);\n  letter-spacing: var(--letter-spacing-h4);\n}\n.document-note-dialog__header p {\n  margin-top: var(--space-1);\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n  line-height: var(--line-height-body-sm);\n}\n.document-note-dialog__header > button {\n  display: grid;\n  width: 36px;\n  height: 36px;\n  flex: 0 0 auto;\n  place-items: center;\n  border: 0;\n  border-radius: var(--radius-md);\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n.document-note-dialog__header > button:hover { background: var(--surface-secondary); }\n.document-note-dialog__body { padding: var(--space-6); }\n.document-note-dialog__body label {\n  display: block;\n  margin-bottom: var(--space-2);\n  font-size: var(--font-size-label-md);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-label-md);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.document-note-dialog__body textarea {\n  width: 100%;\n  min-height: 144px;\n  resize: vertical;\n  padding: var(--space-3) var(--space-4);\n  border: 0;\n  border-radius: var(--radius-md);\n  outline: none;\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font-family: var(--font-family-primary);\n  font-size: var(--font-size-body-sm);\n  line-height: var(--line-height-body-sm);\n}\n.document-note-dialog__body textarea:focus {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 0;\n}\n.document-note-dialog__body textarea[aria-invalid=\"true\"] {\n  outline: 2px solid var(--danger-default);\n}\n.document-note-dialog__meta {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-3);\n  margin-top: var(--space-2);\n  color: var(--text-tertiary);\n  font-size: var(--font-size-body-xs);\n  line-height: var(--line-height-body-xs);\n}\n.document-note-dialog__meta [role=\"alert\"] { color: var(--danger-text); }\n.document-note-dialog__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-3);\n  padding: var(--space-4) var(--space-6) var(--space-6);\n}\n.document-note-dialog__actions button {\n  min-height: 40px;\n  padding: 0 var(--space-4);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font-family: var(--font-family-primary);\n  font-size: var(--font-size-label-md);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-label-md);\n  letter-spacing: var(--letter-spacing-label-md);\n  cursor: pointer;\n}\n.document-note-dialog__actions button.primary {\n  border-color: var(--interactive-default);\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n}\n.document-note-dialog__actions button:hover { background: var(--surface-secondary); }\n.document-note-dialog__actions button.primary:hover { background: var(--interactive-hover); }\n.document-note-dialog__header button:focus-visible,\n.document-note-dialog__actions button:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n@media (max-width: 640px) {\n  .document-note-dialog__header,\n  .document-note-dialog__body { padding: var(--space-4); }\n  .document-note-dialog__actions { padding: 0 var(--space-4) var(--space-4); }\n  .document-note-dialog__actions button { flex: 1; }\n}\n.credit-detail-error {\n  color: var(--danger-text);\n}\n@media (max-width: 1200px) {\n  .credit-detail-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n@media (max-width: 1024px) {\n  .credit-detail-main {\n    margin-left: 0;\n  }\n  .credit-detail-page {\n    padding: var(--space-6);\n  }\n}\n@media (max-width: 640px) {\n  .credit-detail-page {\n    padding: var(--space-4);\n  }\n  .credit-detail-heading,\n  .credit-detail-identities {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .credit-detail-summary {\n    grid-template-columns: 1fr;\n  }\n  .credit-detail-card {\n    padding: var(--space-4);\n  }\n  .credit-detail-actions {\n    flex-wrap: wrap;\n  }\n  .credit-detail-heading h1 {\n    font-size: var(--font-size-h2);\n  }\n  .adjustment-note-detail-page .credit-detail-heading h1 {\n    font-size: 24px;\n    line-height: 30px;\n    letter-spacing: -0.36px;\n  }\n  .credit-detail-totals dl {\n    min-width: 0;\n    width: 100%;\n  }\n}\n\n.credit-detail-shell * {\n  box-sizing: border-box;\n}\n\n.credit-detail-notes input { width:100%; padding:var(--space-3); border:1px solid var(--border-default); border-radius:var(--radius-md); background:var(--surface-secondary); color:var(--text-primary); font:inherit; margin:var(--space-3) 0; }\n\n.credit-note-detail-skeleton__heading > div:first-child {\n  min-width: 0;\n  gap: var(--space-2);\n}\n.credit-note-detail-skeleton .app-skeleton { max-width: 100%; }\n.adjustment-note-detail-page .credit-note-detail-skeleton {\n  gap: var(--space-5);\n}\n.credit-note-detail-skeleton__heading > .credit-note-detail-skeleton__actions {\n  flex-direction: row;\n  flex-shrink: 0;\n}\n@media (max-width: 640px) {\n  .adjustment-note-detail-page .credit-note-detail-skeleton__heading > div:first-child > .app-skeleton:first-child {\n    height: 30px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
